<div *ngFor="let position of bannerPositionArray" class="grid xs-p-16">
  <div class="grid__l-12">
    <h4 class="xs-mb-0 text-bold">Pozicija {{position.name}}</h4>
  </div>
  <div *ngFor="let banner of bannersByPosition[position.value]" class="grid__l-4 grid__xl-3 xs-mb-0">
    <div class="wrapper-banner-preview">
      <img class="preview-image" [src]="banner.image.full_path" alt="">
      <div class="wrapper-footer-banner-preview">
        <span>{{banner.active ? 'Aktivan' : 'Neaktivan'}}</span>
        <span>Pozicija {{position.name}}</span>
        <div class="wrapper-buttons-banner-preview">
          <i (click)="bannerForEdit.emit(banner)" class="fa-solid fa-pen-to-square"></i>
          <i (click)="bannerForDelete.emit(banner)" class="fa-solid fa-trash"></i>
        </div>
      </div>
    </div>
  </div>
</div>
